import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import AddressComponentPage from './AddressComponentPage';
import { ConditionalPanel } from 'web-ui-components/lib/layout/content';
import {
  onFindAddressClick,
  onSelectAddressClick,
  onAddManuallyClick,
  addressSelector
} from '../../store/address';
import { resetRequiredFields } from './addressUtils/addressUtils';
class AddressComponent extends Component {
  componentDidUpdate() {
    const { type, formValues, isAddMunuallyClicked } = this.props;
    resetRequiredFields(isAddMunuallyClicked, type, formValues);
  }

  render() {
    const {
      type,
      businessId,
      formValues,
      onAddManuallyClick,
      onFindAddressClick,
      onSelectAddressClick,
      isAddMunuallyClicked,
      postCodeAddressList,
      isPostCodeListError,
      saveFormValues
    } = this.props;
    return (
      <ConditionalPanel isVisible>
        <AddressComponentPage
          type={type}
          businessId={businessId}
          onFindAddressClick={(postCode) => {
            onFindAddressClick(postCode, type);
          }}
          onAddManuallyClick={() => {
            onAddManuallyClick(type, true);
          }}
          postCodeAddressList={postCodeAddressList}
          isAddMunuallyClicked={isAddMunuallyClicked}
          onSelectAddressClick={(id, type) => {
            onSelectAddressClick(id, type);
          }}
          isPostCodeListError={isPostCodeListError}
          formValues={formValues}
          saveFormValues={(name, value) => saveFormValues(name, value)}
        />
      </ConditionalPanel>
    );
  }
}

AddressComponent.propTypes = {
  type: PropTypes.string,
  postCodeAddressList: PropTypes.array
};

const actionCreators = {
  onFindAddressClick,
  onSelectAddressClick,
  onAddManuallyClick
};

const mapDispatchToProps = (dispatch) => bindActionCreators(actionCreators, dispatch);

const mapStateToProps = (state, ownProps) => {
  return {
    isAddMunuallyClicked: addressSelector.isAddManuallyClicked(state, ownProps.type),
    postCodeAddressList: addressSelector.postCodeAddressList(state, ownProps.type),
    isPostCodeListError: addressSelector.isPostCodeListError(state, ownProps.type)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AddressComponent);
